module.exports = "/img/_/_/_/assets/images/avatar/portrait/female//rogue.png?33385b5799ef53edf76289cff82654c2";